import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  toolbar: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    display: 'flex',
    padding: '1.5rem 0',
  },
  products: {
    width: '100%',
  },
  root: {
    flexGrow: 1,
  },
  productGrid: {
    padding: theme.spacing(2, 0),
  },
  topbar: {
    padding: '1.5rem 1rem 2rem',
    marginBottom: '1rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    overflow: 'auto',
    flexWrap: 'wrap',
    gap: '0.5rem',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'flex-start',
      flexWrap: 'nowrap',
    },
  },
  categoryCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    fontFamily: 'Inter, sans-serif',
    fontSize: '0.85rem',
    fontWeight: 500,
    color: 'var(--color-plum)',
    cursor: 'pointer',
    padding: '0.5rem',
    borderRadius: '20px',
    transition: 'transform .2s ease',
    '&:hover': {
      transform: 'translateY(-3px)',
      '& > div': {
        boxShadow: '0 14px 30px rgba(232, 72, 79, 0.18)',
      },
      '& > div > img': {
        transform: 'scale(1.06)',
        filter: 'grayscale(0%)',
      },
    },
  },
  categoryImgBox: {
    borderRadius: '50%',
    width: '100px',
    height: '100px',
    margin: '8px',
    border: '3px solid transparent',
    background:
      'linear-gradient(white, white) padding-box,' +
      'linear-gradient(135deg, var(--color-coral-soft), var(--color-gold)) border-box',
    boxShadow: '0 8px 22px rgba(61, 30, 92, 0.10)',
    overflow: 'hidden',
    transition: 'all .25s ease',
  },
  categoryImg: {
    borderRadius: '50%',
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    filter: 'grayscale(0%)',
    transition: 'transform .25s ease',
  },
  active: {
    color: 'var(--color-coral-deep)',
    fontWeight: 700,
    '& > div': {
      background:
        'linear-gradient(white, white) padding-box,' +
        'linear-gradient(135deg, var(--color-coral), var(--color-coral-deep)) border-box',
      boxShadow: '0 14px 32px rgba(232, 72, 79, 0.28)',
      transform: 'translateY(-2px)',
    },
    '& > div > img': {
      transform: 'scale(1.04)',
      filter: 'grayscale(0%)',
    },
  },
  filters: {
    paddingBottom: '1rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '0.6rem',
  },
}));
